import { render } from "./OfficialSite.vue?vue&type=template&id=3528efc2&scoped=true"
import script from "./OfficialSite.vue?vue&type=script&lang=js"
export * from "./OfficialSite.vue?vue&type=script&lang=js"

import "./OfficialSite.vue?vue&type=style&index=0&id=3528efc2&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3528efc2"]])

export default __exports__